import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    document.getElementById(event.params.id)?.showModal()
  }
}
